'use client';
import { useState } from 'react';
import Image from 'next/image';
import Button from '../components/ui/Button';
import { useTranslations } from '../utils/translations';

export default function HeroSection() {
  const { t } = useTranslations();
  const [selectedReading, setSelectedReading] = useState<string>('');

  const handleNineCardReading = () => {
    setSelectedReading('9-cards');
    window.location.href = '/card-selection';
  };

  const handleQuestionReading = () => {
    setSelectedReading('question');
    window.location.href = '/card-question';
  };

  return (
    <section className="relative w-full bg-[var(--bg-main)] py-12 sm:py-20 overflow-hidden mt-5">
      {/* DEKORATIVNÍ HVĚZDY - Absolutně pozicované pozadí */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="relative w-full h-full max-w-[1400px] mx-auto">
          {/* Horní hvězdy */}
          <Image src="/images/img_vector.svg" alt={t('home.hero.accessibility.star_alt')} width={26} height={22} className="absolute top-10 left-[5%] w-5 h-auto animate-pulse rotate-12" />
          <Image src="/images/img_vector_yellow_a700.svg" alt={t('home.hero.accessibility.star_alt')} width={38} height={32} className="absolute top-20 left-[15%] w-8 h-auto hidden md:block animate-pulse" />
          <Image src="/images/img_vector_yellow_a700_30x36.svg" alt={t('home.hero.accessibility.star_alt')} width={36} height={30} className="absolute top-10 right-[10%] w-9 h-auto animate-pulse" />
          <Image src="/images/img_vector_yellow_a700_30x34.svg" alt={t('home.hero.accessibility.star_alt')} width={34} height={30} className="absolute top-[40%] right-[5%] w-7 h-auto animate-pulse" />
          
          {/* Spodní hvězdy */}
          <Image src="/images/img_vector_yellow_a700_32x38.svg" alt={t('home.hero.accessibility.star_alt')} width={38} height={32} className="absolute bottom-20 right-[15%] w-8 h-auto animate-pulse" />
          <Image src="/images/img_vector.svg" alt={t('home.hero.accessibility.star_alt')} width={26} height={22} className="absolute bottom-10 left-[10%] w-6 h-auto animate-pulse" />
        </div>
      </div>
      <div className="relative z-10 w-full max-w-[1600px] mx-auto px-4 flex flex-col items-center">
        
        {/* Heading */}
        <div className="text-center mb-8">
        <h1
                className="text-center text-[var(--text-primary)] font-medieval font-medium text-[32px] sm:text-[40px] md:text-[52px] lg:text-[64px] leading-tight drop-shadow-text-dark dark:drop-shadow-text-light break-words"
                style={{
                  fontFamily: 'MedievalSharp',
                  textShadow: '0.8px 0px 0px currentColor, -0.8px 0px 0px currentColor'
                }}>

            {t('home.hero.heading')?.split(' ')?.slice(0, 2)?.join(' ')} <br className="hidden sm:block" /> {t('home.hero.heading')?.split(' ')?.slice(2)?.join(' ')}
        </h1>
          
          <p className="text-[var(--text-accent)] font-inter font-medium text-[18px] sm:text-[18px] md:text-[20px] lg:text-[24px] leading-[24px] sm:leading-[24px] md:leading-[30px] lg:leading-[34px] mt-6 max-w-2xl mx-auto px-[15px]">
            {t('home.hero.subheading')}
          </p>
        </div>

        {/* Main Action Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 w-full max-w-xl items-center justify-center mt-2.5 -mb-2.5">
          <Button
                onClick={handleNineCardReading}
                className="bg-[#b71b90] hover:bg-[#961676] text-[#ffffff] font-bold rounded-full shadow-lg py-3 px-6 flex items-center justify-center gap-3 transition-all duration-300 ease-in-out border-2 border-[#b71b90] hover:scale-105 hover:shadow-xl active:scale-95 active:opacity-90">

            <span>{t('home.hero.nine_cards_button')}</span>
            <Image src="/images/img_vector_white_a700.svg" alt={t('home.hero.accessibility.arrow_alt')} width={20} height={12} />
          </Button>

          <Button
                onClick={handleQuestionReading}
                className="bg-[#F8FFBE] hover:bg-[#e8f5a1] text-black font-bold rounded-full shadow-lg py-3 px-6 flex items-center justify-center gap-3 transition-all duration-300 ease-in-out border-2 border-[#f7ffc0] hover:scale-105 hover:shadow-xl active:scale-95 active:opacity-90">

            <span>{t('home.hero.question_button')}</span>
            <Image src="/images/img_vector_black_900.svg" alt={t('home.hero.accessibility.arrow_alt')} width={20} height={12} />
          </Button>
        </div>

      </div>
    </section>
  );

}